import { Client } from "./client";
import { EquipmentItemCreateData, EquipmentItemData, EquipmentListResponse, EquipmentResponse } from "@/types/equipmentTypes";
import { FusaReply } from "@/types/replyTypes";

export class EquipmentController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async readAllForProcedureInstance(procedureInstanceId: string): Promise<EquipmentListResponse> {
    return this.client.read(`/api/equipment/readAllForProcedureInstance/${procedureInstanceId}`);
  }

  public async read(id: string): Promise<EquipmentResponse> {
    return this.client.read(`/api/equipment/${id}`);
  }

  public async create(equipment: EquipmentItemCreateData): Promise<EquipmentResponse> {
    return this.client.create(`/api/equipment`, equipment);
  }

  public async update(equipment: EquipmentItemData): Promise<EquipmentResponse> {
    return this.client.update(`/api/equipment/${equipment.id}`, equipment);
  }

  public async delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/equipment/${id}`);
  }
}